module.exports = __webpack_public_path__ + "images/category_lp/common/reason3-man-50@2x_abcc6cb33f9bef0b08e7d1d3245c0271.jpg";